import { createSignal, Show, type VoidComponent } from "solid-js";
import { useTranslation } from "../../../state/i18n.tsx";
import Drawer from "../../../components/drawer/Drawer.tsx";
import VersionHistoryContent from "./VersionHistoryContent.tsx";
import { makeEventListener } from "@solid-primitives/event-listener";
import VersionHistoryShowEvent from "../../../events/VersionHistoryShowEvent";

const VersionHistoryDrawer: VoidComponent = () => {
  const { t } = useTranslation();
  const [open, setOpen] = createSignal<boolean>(false);

  makeEventListener<Record<string, VersionHistoryShowEvent>>(document, VersionHistoryShowEvent.name, () => {
    setOpen(true);
  });

  return (
    <Drawer title={t(($) => $.VERSION_HISTORY_DRAWER_TITLE)} open={open()} setOpen={setOpen} fullscreen>
      <Show when={open()}>
        <VersionHistoryContent />
      </Show>
    </Drawer>
  );
};

export default VersionHistoryDrawer;
